export default __webpack_public_path__ + "static/media/56t.7b616d50.jpg";